import { render, staticRenderFns } from "./PedidosConfirmados.vue?vue&type=template&id=428c7dfa"
import script from "./PedidosConfirmados.vue?vue&type=script&lang=js"
export * from "./PedidosConfirmados.vue?vue&type=script&lang=js"
import style0 from "./PedidosConfirmados.vue?vue&type=style&index=0&id=428c7dfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports